import { useMemo } from "react";
import { Repeat } from "lucide-react";
import SearchableSelect from "../SearchableSelect";
import { Field } from "./fields";

function subPlaceholder({ locationId, baskaTaseron, multiMode }) {
  if (!locationId) return "Önce lokasyon seçin";
  if (baskaTaseron) return "İşi yapan taşeronu seçin…";
  if (multiMode) return "Atanan taşeronlardan seçin…";
  return "Cari listesinde arayın…";
}

// Veri girişi: Taşeron alanı (atama kartından otomatik / çoklu atama seçimi / başka taşeron)
export default function SubcontractorField({ form, change, editMode, editEntry, baskaTaseron, setBaskaTaseron, multiMode, assignment, assignOptions, subs, onNewCari }) {
  const options = useMemo(() => {
    if (multiMode && !baskaTaseron) return (assignOptions || []).filter((a) => a.subcontractor_id).map((a) => ({ value: a.subcontractor_id, label: a.subcontractor_name || (subs.find((s) => s.id === a.subcontractor_id) || {}).name || "" }));
    return subs.filter((s) => s.status === "Aktif").map((s) => ({ value: s.id, label: s.name }));
  }, [multiMode, baskaTaseron, assignOptions, subs]);
  const locked = !baskaTaseron && !multiMode && !!(assignment && assignment.subcontractor_id);
  return (
    <Field label="Taşeron">
      <div className="flex items-start gap-2">
        <div className="flex-1">
          <SearchableSelect testid="entry-subcontractor" disabled={!form.location_id || locked} value={form.subcontractor_id} onChange={(v) => change("subcontractor_id", v)}
            placeholder={subPlaceholder({ locationId: form.location_id, baskaTaseron, multiMode })}
            options={options}
            footer={{ label: "Yeni Cari Aç", testid: "entry-cari-new", onClick: onNewCari }} />
        </div>
        {!editMode && <button type="button" onClick={() => setBaskaTaseron(!baskaTaseron)} disabled={!form.location_id || !assignment} data-testid="entry-baska-taseron"
          title="İşi, atanan taşeron yerine başka bir taşeron yaptıysa buradan değiştirin"
          className={`shrink-0 inline-flex items-center gap-1.5 px-2.5 py-2 rounded-md text-[11px] font-semibold border transition-colors disabled:opacity-40 ${baskaTaseron ? "bg-sky-600 text-white border-sky-600" : "bg-white text-slate-600 border-slate-300 hover:border-sky-400"}`}>
          <Repeat className="w-3.5 h-3.5" /> Başka Taşeron
        </button>}
      </div>
      {editMode && form.subcontractor_id !== editEntry.subcontractor_id && (
        <div className="text-[11px] text-sky-700 mt-1" data-testid="edit-doer-hint">Mevcut atanan: {editEntry.subcontractor_name} — hakediş seçilen taşerona ödenecek.</div>
      )}
      {multiMode && !baskaTaseron && (
        <div className="text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-2.5 py-1.5" data-testid="multi-assign-warning">
          Bu şubeye bu hizmet için {assignOptions.length} taşeron ataması yapılmıştır. Hizmeti sağlayan taşeronu seçiniz.
        </div>
      )}
      {!multiMode && assignment && !baskaTaseron && (
        <div className="text-[11px] text-emerald-700" data-testid="sub-auto-hint">Atama kartından otomatik geldi — kalıcı değişiklik için proje kartı → Hizmetler → Atamalar'ı kullanın.</div>
      )}
      {baskaTaseron && (
        <div className="text-[11px] text-sky-800 bg-sky-50 border border-sky-200 rounded-md px-2.5 py-1.5" data-testid="baska-taseron-hint">
          İşi yapan taşeronu seçin — müşteri birim fiyatı mevcut atanan fiyattan otomatik gelir, yalnızca taşeron birim fiyatını manuel girersiniz. Hakediş işi yapan taşerona ödenir.
        </div>
      )}
    </Field>
  );
}
